/* ICE Diamonds — Tennis PDP buy box.

   BUNDLE MODES — read from the markup, not configured:
     • ONE bundle  → toggle. The page opens on the bare product; the row is an
       optional upgrade that switches on and back off. A radio has no way back
       once picked, which is the wrong model for "add this if you want it".
     • TWO OR MORE → radio. Picking one deselects the others.

   BUNDLE PRICE IS THE WHOLE BASKET, not the add-on delta. "+\u20aa900" asks the
   shopper to do the arithmetic against a number sitting 200px away; the full
   figure with the pre-discount total struck through next to it makes the
   saving visible without any mental work. This is now identical in both modes.

   CHECKOUT, NOT CART. The button posts the line items and then goes straight
   to /checkout. The cart page adds a step that only invites second thoughts on
   a single-product landing page, and there is nothing on it this page has not
   already shown. Anything already sitting in the cart still comes along — this
   skips the cart page, it does not empty it.

   CTA COPY MIGRATION. The label lives in the section setting, whose stored
   value in templates/product.igi.json still reads "הוספה לעגלה". That file is
   ~99KB and themeFilesUpsert has no partial patch, so the legacy strings are
   swapped here instead. Type anything else into the setting and it is left
   alone — only these exact old defaults are replaced.

   REVIEWS — relocated at runtime into the media column, under the thumbnails,
   and turned into a one-at-a-time carousel with dots. Doing it here rather
   than in Liquid keeps the section template untouched.

   Gallery is a scroll-snap track — finger swipe is native, no library. */
(function () {
  'use strict';

  var CTA_TEXT   = '\u05dc\u05e8\u05db\u05d9\u05e9\u05d4 \u05de\u05d4\u05d9\u05e8\u05d4 \u05d5\u05de\u05d0\u05d5\u05d1\u05d8\u05d7\u05ea';
  var CTA_LEGACY = [
    '\u05d4\u05d5\u05e1\u05e4\u05d4 \u05dc\u05e1\u05dc',
    '\u05d4\u05d5\u05e1\u05e4\u05d4 \u05dc\u05e2\u05d2\u05dc\u05d4',
    '\u05d4\u05d5\u05e1\u05e3 \u05dc\u05e1\u05dc',
    '\u05d4\u05d5\u05e1\u05d9\u05e4\u05d5 \u05dc\u05e1\u05dc'
  ];

  function root_(){
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(c){
    var n = c / 100;
    var s = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    return '\u20aa' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* The availability badge ships a checkmark in the markup. A live dot reads
     as "right now" where a tick reads as "confirmed", so swap it here. */
  function dressBadges(root){
    root.querySelectorAll('.itp-badge--green').forEach(function(b){
      if(b.dataset.itpDot) return;
      b.dataset.itpDot = '1';
      Array.prototype.slice.call(b.childNodes).forEach(function(n){
        if(n.nodeType === 3){
          n.textContent = n.textContent.replace(/^[\s\u2713\u2714]+/, ' ');
        }
      });
      var dot = document.createElement('span');
      dot.className = 'itp-badge__dot';
      dot.setAttribute('aria-hidden','true');
      b.insertBefore(dot, b.firstChild);
    });
  }

  /* Move the reviews block under the gallery and run it as a carousel. */
  function initReviews(root){
    var revs = root.querySelector('.itp-revs');
    var media = root.querySelector('.itp__media');
    if(!revs || !media || revs.dataset.itpBound) return;
    revs.dataset.itpBound = '1';

    media.appendChild(revs);

    var track = revs.querySelector('.itp-revs__track');
    var cards = revs.querySelectorAll('.itp-rev');
    if(!track || cards.length < 2) return;

    cards.forEach(function(card){
      var ava = card.querySelector('.itp-rev__ava');
      if(ava && !card.querySelector('.itp-rev__photo')){
        var photo = ava.cloneNode(true);
        photo.className = 'itp-rev__photo';
        card.appendChild(photo);
      }
    });

    var dots = document.createElement('div');
    dots.className = 'itp-revs__dots';
    cards.forEach(function(_, i){
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'itp-revs__dot' + (i === 0 ? ' is-on' : '');
      d.setAttribute('aria-label', '\u05d1\u05d9\u05e7\u05d5\u05e8\u05ea ' + (i + 1));
      d.addEventListener('click', function(){ go(i, true); });
      dots.appendChild(d);
    });
    revs.appendChild(dots);

    var current = 0, timer = null, paused = false;

    function mark(i){
      current = i;
      dots.querySelectorAll('.itp-revs__dot').forEach(function(d, k){
        d.classList.toggle('is-on', k === i);
      });
    }

    function go(i, manual){
      if(i < 0) i = cards.length - 1;
      if(i >= cards.length) i = 0;
      var card = cards[i];
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
      if(manual) restart();
    }

    function restart(){
      clearInterval(timer);
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function(){
        if(!paused) go(current + 1);
      }, 5500);
    }

    var tick;
    track.addEventListener('scroll', function(){
      clearTimeout(tick);
      tick = setTimeout(function(){
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        cards.forEach(function(c, i){
          var centre = c.offsetLeft - track.offsetLeft + c.clientWidth / 2;
          var dist = Math.abs(centre - mid);
          if(dist < bestD){ bestD = dist; best = i; }
        });
        mark(best);
      }, 80);
    }, { passive: true });

    revs.addEventListener('mouseenter', function(){ paused = true; });
    revs.addEventListener('mouseleave', function(){ paused = false; });
    track.addEventListener('touchstart', function(){ paused = true; }, { passive: true });

    restart();
  }

  function init(root){
    if(!root || root.dataset.itpBound) return;
    root.dataset.itpBound = '1';

    dressBadges(root);
    initReviews(root);

    var raw = root.querySelector('[data-itp-variants]');
    if(!raw) return;
    var variants;
    try { variants = JSON.parse(raw.textContent); } catch(e){ return; }
    if(!variants || !variants.length) return;

    var nowEl  = root.querySelector('[data-itp-now]');
    var wasEl  = root.querySelector('[data-itp-was]');
    var offEl  = root.querySelector('[data-itp-off]');
    var instEl = root.querySelector('[data-itp-inst]');
    var cta    = root.querySelector('[data-itp-cta]');
    var track  = root.querySelector('.itp-gal__main');
    var instN  = parseInt(root.dataset.itpInstalments || '5', 10);

    var bundles  = Array.prototype.slice.call(root.querySelectorAll('.itp-bundle'));
    var isToggle = bundles.length === 1;
    if(isToggle) root.classList.add('itp--toggle');

    /* ---------- gallery ---------- */
    var slides = root.querySelectorAll('[data-slide]');

    if(track && slides.length > 1 && !root.querySelector('.itp-gal__dots')){
      var gdots = document.createElement('div');
      gdots.className = 'itp-gal__dots';
      Array.prototype.forEach.call(slides, function(s, i){
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'itp-gal__dot' + (i === 0 ? ' is-on' : '');
        d.setAttribute('data-dot', i);
        d.setAttribute('aria-label', '\u05de\u05d3\u05d9\u05d4 ' + (i + 1));
        gdots.appendChild(d);
      });
      track.insertAdjacentElement('afterend', gdots);
    }

    function setActive(i){
      root.querySelectorAll('[data-thumb]').forEach(function(t){
        t.classList.toggle('is-on', t.getAttribute('data-thumb') === String(i));
      });
      root.querySelectorAll('[data-dot]').forEach(function(d){
        d.classList.toggle('is-on', d.getAttribute('data-dot') === String(i));
      });
    }

    /* pause any playing clip when the shopper moves off it */
    function stopVideos(){
      root.querySelectorAll('.itp-gal__slide video').forEach(function(vid){
        if(!vid.paused) vid.pause();
      });
    }

    function goTo(i){
      var slide = root.querySelector('[data-slide="' + i + '"]');
      if(!slide || !track) return;
      stopVideos();
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    if(track){
      var gtick;
      track.addEventListener('scroll', function(){
        clearTimeout(gtick);
        gtick = setTimeout(function(){
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestD = Infinity;
          root.querySelectorAll('[data-slide]').forEach(function(s){
            var c = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
            var d = Math.abs(c - mid);
            if(d < bestD){ bestD = d; best = s.getAttribute('data-slide'); }
          });
          setActive(best);
        }, 60);
      }, { passive: true });
    }

    root.addEventListener('click', function(e){
      var t = e.target.closest('[data-thumb]');
      if(t){ goTo(t.getAttribute('data-thumb')); return; }
      var d = e.target.closest('[data-dot]');
      if(d){ goTo(d.getAttribute('data-dot')); }
    });

    /* ---------- variants ---------- */
    var chosen = [];
    root.querySelectorAll('[data-itp-opt]').forEach(function(g){
      var i  = parseInt(g.getAttribute('data-itp-opt'), 10);
      var on = g.querySelector('[aria-checked="true"]');
      chosen[i] = on ? on.getAttribute('data-itp-val') : null;
    });

    function match(){
      return variants.filter(function(v){
        return chosen.every(function(val,i){ return val === null || v.options[i] === val; });
      })[0] || null;
    }

    function availability(){
      root.querySelectorAll('[data-itp-opt]').forEach(function(g){
        var i = parseInt(g.getAttribute('data-itp-opt'), 10);
        g.querySelectorAll('[data-itp-val]').forEach(function(btn){
          var probe = chosen.slice();
          probe[i] = btn.getAttribute('data-itp-val');
          var ok = variants.some(function(v){
            return v.available && probe.every(function(val,k){ return val === null || v.options[k] === val; });
          });
          if(btn.classList.contains('itp-pill')) btn.disabled = !ok;
          btn.style.opacity = ok ? '' : '.32';
        });
      });
    }

    function active(){ return root.querySelector('.itp-bundle.is-on'); }

    function selectsIn(b){
      if(!b) return [];
      var box = root.querySelector('[data-itp-sizes="' + b.dataset.key + '"]');
      if(!box) return [];
      return Array.prototype.map.call(box.querySelectorAll('select'), function(sel){
        var o = sel.options[sel.selectedIndex];
        return {
          id:      Number(sel.value),
          price:   parseInt(o.getAttribute('data-price'), 10) || 0,
          compare: parseInt(o.getAttribute('data-compare'), 10) || 0
        };
      });
    }

    function totals(b, unit, unitWas){
      var adds = selectsIn(b);
      var pct  = b ? (parseFloat(b.dataset.discount) || 0) : 0;
      var gross = unit, was = unitWas;
      adds.forEach(function(a){
        gross += a.price;
        was   += (a.compare && a.compare > a.price) ? a.compare : a.price;
      });
      var net = Math.round(gross * (1 - pct / 100));
      return { net: net, was: Math.max(was, gross) };
    }

    function render(){
      var v = match();
      availability();
      if(!v){
        if(cta){ cta.disabled = true; cta.textContent = '\u05d0\u05d6\u05dc \u05de\u05d4\u05de\u05dc\u05d0\u05d9'; }
        return;
      }

      var unit    = v.price;
      var unitWas = (v.compare_at_price && v.compare_at_price > unit) ? v.compare_at_price : unit;

      /* every card shows what the basket costs if that card is the choice */
      bundles.forEach(function(el){
        var pe = el.querySelector('[data-itp-bprice]');
        var we = el.querySelector('[data-itp-bwas]');
        var t2 = totals(el, unit, unitWas);

        if(pe) pe.textContent = money(t2.net);
        if(we){
          var show = t2.was > t2.net;
          we.textContent = show ? money(t2.was) : '';
          we.style.display = show ? '' : 'none';
        }
      });

      var t = totals(active(), unit, unitWas);

      if(nowEl) nowEl.textContent = money(t.net);
      if(wasEl){
        var s = t.was > t.net;
        wasEl.textContent = s ? money(t.was) : '';
        wasEl.style.display = s ? '' : 'none';
      }
      if(offEl){
        var save = t.was - t.net;
        offEl.textContent = save > 0 ? ('\u05d7\u05e1\u05db\u05ea ' + money(save)) : '';
        offEl.style.display = save > 0 ? 'inline-flex' : 'none';
      }
      if(instEl && instN > 1){
        instEl.textContent = '\u05d0\u05d5 \u05d1' + instN + ' \u05ea\u05e9\u05dc\u05d5\u05de\u05d9\u05dd \u05e9\u05dc '
          + money(Math.round(t.net / instN)) + ' \u05dc\u05dc\u05d0 \u05e8\u05d9\u05d1\u05d9\u05ea';
      }

      if(cta){
        cta.disabled = !v.available;
        cta.textContent = v.available ? (cta.dataset.label || cta.textContent) : '\u05d0\u05d6\u05dc \u05de\u05d4\u05de\u05dc\u05d0\u05d9';
      }

      if(v.featured_image && v.featured_image.src){
        var base = v.featured_image.src.split('?')[0].split('/').pop();
        root.querySelectorAll('.itp-gal__slide img').forEach(function(img){
          var b2 = (img.getAttribute('src') || '').split('?')[0].split('/').pop();
          if(b2 === base){
            var sl = img.closest('[data-slide]');
            if(sl) goTo(sl.getAttribute('data-slide'));
          }
        });
      }

      if(window.history && history.replaceState){
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    if(cta){
      var opening = cta.textContent.trim();
      if(CTA_LEGACY.indexOf(opening) !== -1){
        cta.textContent = CTA_TEXT;
      }
      cta.dataset.label = cta.textContent.trim();
    }

    root.querySelectorAll('[data-itp-val]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(btn.disabled) return;
        var i = parseInt(btn.getAttribute('data-itp-i'), 10);
        var g = root.querySelector('[data-itp-opt="' + i + '"]');
        if(!g) return;
        g.querySelectorAll('[data-itp-val]').forEach(function(x){ x.setAttribute('aria-checked','false'); });
        btn.setAttribute('aria-checked','true');
        chosen[i] = btn.getAttribute('data-itp-val');
        var lbl = root.querySelector('[data-itp-chosen="' + i + '"]');
        if(lbl) lbl.textContent = chosen[i];
        render();
      });
    });

    function setBundle(el, on){
      el.classList.toggle('is-on', on);
      var input = el.querySelector('input');
      if(input) input.checked = on;
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      var box = root.querySelector('[data-itp-sizes="' + el.dataset.key + '"]');
      if(box) box.classList.toggle('is-on', on);
    }

    bundles.forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        if(isToggle){
          setBundle(el, !el.classList.contains('is-on'));
        } else {
          bundles.forEach(function(x){ setBundle(x, x === el); });
        }
        render();
      });
      el.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); el.click(); }
      });
    });

    root.querySelectorAll('[data-itp-sizes] select').forEach(function(sel){
      sel.addEventListener('change', render);
    });

    if(cta){
      cta.addEventListener('click', function(e){
        e.preventDefault();
        var v = match();
        if(!v || !v.available) return;

        var items = [{ id: v.id, quantity: 1 }];
        selectsIn(active()).forEach(function(a){ if(a.id) items.push({ id: a.id, quantity: 1 }); });

        cta.disabled = true;
        var label = cta.textContent;
        cta.textContent = '\u05de\u05e2\u05d1\u05d9\u05e8 \u05dc\u05ea\u05e9\u05dc\u05d5\u05dd...';

        fetch(root_() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
        .then(function(){ window.location.href = root_() + 'checkout'; })
        .catch(function(){
          cta.disabled = false;
          cta.textContent = label;
          alert('\u05d0\u05d9\u05e8\u05e2\u05d4 \u05ea\u05e7\u05dc\u05d4. \u05e0\u05e1\u05d5 \u05e9\u05d5\u05d1.');
        });
      });
    }

    setActive(0);

    if(isToggle){
      bundles.forEach(function(el){ setBundle(el, false); });
    } else {
      var first = root.querySelector('.itp-bundle.is-on') || bundles[0];
      if(first) bundles.forEach(function(x){ setBundle(x, x === first); });
    }
    render();
  }

  function boot(){ document.querySelectorAll('[data-itp-root]').forEach(init); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
